export const initialValuesUserDetails = {
  email: '',
  password: '',
  confirmPassword: '',
  firstName: '',
  lastName: '',
  title: '',
  terms: false,
};
